import { ROUTES } from '#/config/routes';

/** 產品維修 hub 導覽卡。權限碼待後端補上後再掛 permission。 */
const productRepairNavigate = [
  {
    to: ROUTES.repairRequest,
    title: '報修單',
    subtitle: '查詢與管理報修單',
  },
  {
    to: ROUTES.repairItem,
    title: '維修品項',
    subtitle: '查詢維修品項與備註',
  },
  {
    to: ROUTES.repairReport,
    title: '維修報告',
    subtitle: '查詢與管理維修報告',
  },
  {
    to: ROUTES.signReceipt,
    title: '簽收單',
    subtitle: '查詢與管理簽收單',
  },
  {
    to: ROUTES.snProductMapping,
    title: '物料序號',
    subtitle: '查詢物料序號與產品對應',
  },
];

export default productRepairNavigate;
